export default "__VITE_ASSET__BktdN7Dn__"